import sanityClient from '@sanity/client'
import imageUrlBuilder from '@sanity/image-url'

export const client = sanityClient({
  projectId: 'a71uw662',
  dataset: 'production',
  apiVersion: '2022-02-01',
  useCdn: true,
  token: 'skQO7KTz6h7DlkCU0VL6sqI2zdoecUIgLWBWO1HyCuQOs6R1tTod5jhtRDHbJvq4Tl5jMrFZauE8Y0aScs8kDlwC0Dy8cn3Xe8HZsUZJ7xMCe49FgOK4Wm6eSp1SufqltcEABjlKLVgJHJx1NuN21WY1sfMFw8PrnIrk7NihG9nkzdYrDr2o',
})

const builder = imageUrlBuilder(client)

export const urlFor = (source) => builder.image(source)
